import PropTypes from 'prop-types';
import React from 'react';

import LargeTemplate from '../../sp-base-templates/LargeTemplate';
import Image from '../../components/Image/Image';
import Text from '../../components/TextWithAudio';

export default function ImageTextShortTemplate(_ref) {
  var id = _ref.id,
      onClose = _ref.onClose,
      imageSource = _ref.imageSource,
      text = _ref.text,
      audioSource = _ref.audioSource,
      backgroundImageSource = _ref.backgroundImageSource;

  return React.createElement(
    LargeTemplate,
    { id: id, audioSource: audioSource, onClose: onClose, backgroundImage: backgroundImageSource },
    imageSource && React.createElement(Image, { imageSource: imageSource, theme: 'maxHeightTextImage' }),
    React.createElement(Text, { text: text })
  );
}

ImageTextShortTemplate.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func,
  imageSource: PropTypes.string,
  audioSource: PropTypes.string,
  backgroundImageSource: PropTypes.string,
  text: PropTypes.string.isRequired
} : {};

ImageTextShortTemplate.defaultProps = {
  onClose: function onClose() {},
  imageSource: '',
  audioSource: '',
  backgroundImageSource: ''
};